// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"65cb00bf","202":"5bc3a61f","453":"e9e9309c","645":"c04929c6","816":"3776198a","935":"3cf7b6e0"}[chunkId] + ".chunk.js";
};